import { sizeToCSS, Size } from '../../UNSAFE_size';
import { coerceArray } from '../../UNSAFE_arrayUtils';

const paddingstartends = [
  'paddingBlockStart',
  'paddingBlockEnd',
  'paddingInlineStart',
  'paddingInlineEnd'
] as const;

type PaddingStartEnd = typeof paddingstartends[number];
type PaddingStartEndProps = { [key in PaddingStartEnd]?: Size };

export type PaddingProps = {
  padding?: Size | [Size] | [Size, Size] | [Size, Size, Size] | [Size, Size, Size, Size];
} & PaddingStartEndProps;

const paddingInterpolations = {
  padding: ({ padding }: Pick<PaddingProps, 'padding'>) => {
    if (padding === undefined) {
      return {};
    } else {
      const [
        topPadding,
        rightPadding = topPadding,
        bottomPadding = topPadding,
        leftPadding = rightPadding
      ] = coerceArray(padding) as
        | [Size]
        | [Size, Size]
        | [Size, Size, Size]
        | [Size, Size, Size, Size];
      return {
        padding: `${sizeToCSS(topPadding)} ${sizeToCSS(rightPadding)} 
        ${sizeToCSS(bottomPadding)} ${sizeToCSS(leftPadding)}`
      };
    }
  },
  paddingBlockStart: ({ paddingBlockStart }: Pick<PaddingProps, 'paddingBlockStart'>) =>
    paddingBlockStart === undefined
      ? {}
      : {
          paddingBlockStart: `${sizeToCSS(paddingBlockStart)}`
        },
  paddingBlockEnd: ({ paddingBlockEnd }: Pick<PaddingProps, 'paddingBlockEnd'>) =>
    paddingBlockEnd === undefined
      ? {}
      : {
          paddingBlockEnd: `${sizeToCSS(paddingBlockEnd)}`
        },
  paddingInlineStart: ({ paddingInlineStart }: Pick<PaddingProps, 'paddingInlineStart'>) =>
    paddingInlineStart === undefined
      ? {}
      : {
          paddingInlineStart: `${sizeToCSS(paddingInlineStart)}`
        },
  paddingInlineEnd: ({ paddingInlineEnd }: Pick<PaddingProps, 'paddingInlineEnd'>) =>
    paddingInlineEnd === undefined
      ? {}
      : {
          paddingInlineEnd: `${sizeToCSS(paddingInlineEnd)}`
        }
};

export { paddingInterpolations };
